import React, { useState } from 'react';
import folderGreen from '../assets/FolderGreen.png';
import folderBlue from '../assets/FolderCode.png';
import folderOrange from '../assets/FolderOrange.png';
import folderYellow from '../assets/FolderYellow.png';
import folderLime from '../assets/FolderLime.png';
import FolderPictures from '../assets/FolderPictures.png';
import bluefolder from '../assets/FolderBlue.png'
import AboutMe from '../data/constant';
import Experience from '../components/Experience';
import Skills from '../components/Skills';
import Profiles from '../components/Profiles';
import Photos from '../components/Photos';
import ModalMobile from '../components/Mobile/ModalMobile';
import ProjectsMobile from '../components/Mobile/ProjectsMobile';
import Contact from './Contact';

const HomeMobile = () => {
  const [modals, setModals] = useState([]);

  const handleDoubleClick = (title, data) => {
    const newModal = {
      id: new Date().getTime(),
      title: title,
      data: data,
    };
    setModals([...modals, newModal]);
  };

  const closeModal = (id) => {
    setModals(modals.filter(modal => modal.id !== id));
  };

  return (
    <div className='relative flex flex-row left-4 gap-8 flex-wrap mt-6'><div className='relative flex flex-col left-4 gap-4 flex-wrap'>
        <div className='flex flex-col w-fit text-center' onClick={() => handleDoubleClick('About Me', <AboutMe />)}>
          <img src={folderGreen} alt="Green Folder" className='protect-image w-16' />
          <p className='text-white'>About Me</p>
        </div>

        <div className='flex flex-col w-fit text-center' onClick={() => handleDoubleClick('Projects', <ProjectsMobile />)}>
          <img src={folderBlue} alt="Blue Folder" className='protect-image w-16' />
          <p className='text-white'>Projects</p>
        </div>

        <div className='flex flex-col w-fit text-center' onClick={() => handleDoubleClick('Experience', <Experience />)}>
          <img src={folderOrange} alt="Orange Folder" className='protect-image w-16' />
          <p className='text-white'>Experience</p>
        </div>

        <div className='flex flex-col w-fit text-center' onClick={() => handleDoubleClick('Skills', <Skills />)}>
          <img src={folderYellow} alt="Yellow Folder" className='protect-image w-16' />
          <p className='text-white'>Skills</p>
        </div>

    </div>

    <div className='relative flex flex-col left-4 gap-4 flex-wrap'>
      <div className='flex flex-col w-fit text-center' onClick={() => handleDoubleClick('Profiles', <Profiles />)}>
        <img src={folderLime} alt="Lime Folder" className='protect-image w-16' />
        <p className='text-white'>Profiles</p>
      </div>

      <div className='flex flex-col w-fit text-center' onClick={() => handleDoubleClick('Photos', <Photos />)}>
        <img src={FolderPictures} alt="Pictures Folder" className='protect-image w-16' />
        <p className='text-white'>Photos</p>
      </div>

      <div className='flex flex-col w-fit text-center' onClick={() => handleDoubleClick('Contact', <Contact />)}>
        <img src={bluefolder} alt="Pictures Folder" className='protect-image w-16' />
        <p className='text-white'>Contact</p>
      </div>
    </div>
      
      {modals.map(modal => (
        <ModalMobile
          key={modal.id}
          id={modal.id}
          title={modal.title}
          data={modal.data}
          onClose={closeModal} />
      ))}
      </div>
  );
};

export default HomeMobile;
